// @ts-strict-ignore
import * as React from "react";
import { withTheme } from "styled-components";

export const CaretIcon = ({ theme }) => (
  <svg
    width="10px"
    height="17px"
    viewBox="0 0 19 33"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Arrow</title>
    <g
      id="Careers_V5"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <path
        d="M8.38092833,7.87224029 C8.93165017,7.31376181 9.8109007,7.27885691 10.4026886,7.76752558 L10.5170309,7.87224029 L24.9660104,22.5247266 C25.5476863,23.1145951 25.5410448,24.0643193 24.9511764,24.6459951 C24.3981748,25.1913162 23.5288936,25.2195616 22.9431075,24.7349255 L22.8299079,24.6311611 L9.449,11.063 L-3.93194874,24.6311611 C-4.47726981,25.1841627 -5.34607095,25.2245625 -5.93857754,24.7481662 L-6.05321722,24.6459951 C-6.60621886,24.100674 -6.64661866,23.2318729 -6.17022237,22.6393663 L-6.06805126,22.5247266 L8.38092833,7.87224029 Z"
        id="Path-Copy-2"
        fill={theme.textColors.primary}
        fillRule="nonzero"
        transform="translate(9.448980, 16.251701) rotate(-270.000000) translate(-9.448980, -16.251701) "
      ></path>
    </g>
  </svg>
);

export default withTheme(CaretIcon);
